import React from 'react'

import { applyStyle } from '../helpers/styles'
import { useColor } from '../../components/theme/_hooks/colors'
import { useFontSize } from '../../components/theme/_hooks/fontSizes'
import { useMarginStyle } from './margin'

export const useFontStyle = props => {
  const { size, fontSize, color, fontColor, bold, weight, lineHeight, align, underline, noWrap, italic } = props

  const marginStyle = useMarginStyle(props)
  const fontSizeValue = useFontSize(fontSize || size)
  const colorValue = useColor(fontColor || color, 'dark1')

  return React.useMemo(() => {
    return `
      margin: 0;
      white-space: pre-line;
      ${applyStyle('color', colorValue)}
      ${applyStyle('font-size', fontSizeValue)}
      ${applyStyle('font-weight', weight || (bold ? 700 : 400))}
      ${applyStyle('line-height', lineHeight || 1.6)}
      ${applyStyle('text-align', align || 'left')}
      ${applyStyle('text-decoration', underline, 'underline')}
      ${applyStyle('font-style', italic, 'italic')}
      ${applyStyle('white-space', noWrap, 'nowrap')}
      ${marginStyle}
    `
  }, [marginStyle, fontSizeValue, colorValue, weight, bold, lineHeight, align, underline, italic])
}
